<template>
  <BaseSlideOverModal v-model:is-modal-open="localOpen" width="4xl">
    <template #body>
      <ActivityContainer :activities="activities" />
    </template>
  </BaseSlideOverModal>
</template>

<script>
import { mapActions } from 'vuex'
import BaseSlideOverModal from '@c/addf-package/components/modal/BaseSlideOverModal.vue'
import ActivityContainer from '@c/Activity/ActivityContainer.vue'

export default {
  name: 'ActivityLogModal',
  components: {
    ActivityContainer,
    BaseSlideOverModal
  },
  props: {
    open: {
      type: Boolean,
      required: true
    },
    modelType: {
      type: String,
      required: true
    },
    modelId: {
      type: String,
      required: true
    }
  },
  emits: ['close', 'update:open'],
  data() {
    return {
      activities: []
    }
  },
  computed: {
    localOpen: {
      get() {
        return this.open
      },
      set(value) {
        this.$emit('update:open', value)
      }
    }
  },
  watch: {
    open(newValue, oldValue) {
      if (newValue !== oldValue && newValue) {
        this.fetchActivities()
      }
    }
  },
  methods: {
    ...mapActions({
      processFetchActivitiesAction: 'activityLog/fetchActivities'
    }),
    fetchActivities() {
      // do not show the previous journal while the new one loads
      this.activities = []
      const requestedId = this.modelId
      const requestedType = this.modelType
      // a late response for a previous model must not replace the current journal
      const isCurrent = () =>
        requestedId === this.modelId && requestedType === this.modelType
      this.processFetchActivitiesAction({
        id: requestedId,
        model: requestedType
      })
        .then((response) => {
          if (isCurrent()) this.activities = response.activities ?? []
        })
        .catch(() => {
          // the HTTP client already toasts the error: show an empty journal
          if (isCurrent()) this.activities = []
        })
    }
  }
}
</script>
